/**
 * @description: 项目执行人数统计
 * @Date: 2023-01-18 18:04:01
 */
import surveySvg1Vue from './survey-svg-1.vue';
export const surveySvg1 = surveySvg1Vue;
import surveySvg21Vue from './survey-svg-2-1.vue';
export const surveySvg21 = surveySvg21Vue;
import surveySvg22Vue from './survey-svg-2-2.vue';
export const surveySvg22 = surveySvg22Vue;
import surveySvg23Vue from './survey-svg-2-3.vue';
export const surveySvg23 = surveySvg23Vue;
import surveySvg31Vue from './survey-svg-3-1.vue';
export const surveySvg31 = surveySvg31Vue;
import surveySvg41Vue from './survey-svg-4-1.vue';
export const surveySvg41 = surveySvg41Vue;
